import { CellTable } from "@/atoms"
import { getDefaultColumnParams } from "@/helpers/table.helpers"
import { StatusSwitcherCell } from "@/molecules/StatusSwitcherCell"
import { FrequencyCell } from "@/pages/ReportsPage/components/molecules/FrequencyCell"
import { TranslationKeyCell } from "@/pages/ReportsPage/components/molecules/TranslationKeyCell"
import { getCreatorColumn } from "@/pages/ReportsPage/helpers/table.helper"
import { RecurringReportsActionsCell as Control } from "./components/RecurringReportsActionsCell"

import type { ColumnProps } from "./RecurringReportsTab.types"

export const getColumnsTable = (props: ColumnProps) => [
  {
    title: "Report Name",
    render: CellTable,
    ...getDefaultColumnParams("name")
  },
  {
    title: "Report Type",
    render: TranslationKeyCell(props.t),
    ...getDefaultColumnParams("reportTypeKey")
  },
  {
    title: "Scope",
    render: CellTable,
    ...getDefaultColumnParams("scopeName")
  },
  getCreatorColumn(),
  {
    title: "Frequency",
    render: FrequencyCell(props),
    ...getDefaultColumnParams("frequency")
  },
  {
    title: "Status",
    width: 70,
    render: StatusSwitcherCell(
      props.noPermissions,
      props.statusChange,
      props.noPermissions
    ),
    ...getDefaultColumnParams("isEnabled")
  },
  {
    title: null,
    width: 35,
    render: Control(props)
  }
]
